import { Localized } from "@fluent/react"
import { IconButton } from "@mui/material"
import CheckCircleIcon from "@mui/icons-material/CheckCircle"
import ErrorOutline from "@mui/icons-material/ErrorOutline"

export const CompanyStatusLabel = ({ registered }: { registered: boolean }) => {
    return registered ? (
        <>
            <IconButton>
                <CheckCircleIcon color='success' />
            </IconButton>
            <Localized id="companies-registered">
                <span>_Firma zarejestrowana</span>
            </Localized>
        </>
    )
    :
    (
        <>
            <IconButton>
                <ErrorOutline color='error' />
            </IconButton>
            <Localized id="companies-unregistered">
                <span>_Firma niezarejestrowana</span>
            </Localized>
        </>
    )
}